const dashboardHelp = [
  {
    id: "purpose",
    title: "academy_page_title_001",
    body:
      "academy_page_body_001",
  },
  {
    id: "filters",
    title: "academy_page_title_002",
    body:
      "academy_page_body_002",
  },
  {
    id: "kpi",
    title: "academy_page_title_003",
    body:
      "academy_page_body_003",
  },
  {
    id: "charts",
    title: "academy_page_title_004",
    body:
      "academy_page_body_004",
  },
  {
    id: "activity",
    title: "dashboard_recent_activity",
    body:
      "academy_page_body_005",
  },
];

export const ACADEMY_PAGES = {
  dashboard: {
    key: "dashboard",
    route: "/menu/dashboard",
    title: "dashboard_title",
    subtitle: "academy_page_subtitle_001",
    description:
      "academy_page_description_001",
    icon: "▦",
    estimatedMinutes: 3,
    help: dashboardHelp,
    steps: [
      {
        id: "dashboard-header",
        target: '[data-academy="dashboard-header"]',
        title: "dashboard_title",
        body:
          "academy_page_body_006",
        placement: "bottom",
      },
      {
        id: "dashboard-filters",
        target: '[data-academy="dashboard-filters"]',
        title: "academy_page_title_005",
        body:
          "academy_page_body_007",
        placement: "bottom",
      },
      {
        id: "dashboard-kpi",
        target: '[data-academy="dashboard-kpi"]',
        title: "academy_page_title_003",
        body:
          "academy_page_body_008",
        placement: "bottom",
      },
      {
        id: "dashboard-charts",
        target: '[data-academy="dashboard-charts"]',
        title: "academy_page_title_006",
        body:
          "academy_page_body_009",
        placement: "top",
      },
      {
        id: "dashboard-activity",
        target: '[data-academy="dashboard-activity"]',
        title: "academy_page_title_007",
        body:
          "academy_page_body_010",
        placement: "left",
      },
    ],
  },

  contacts: {
    key: "contacts",
    route: "/menu/sales/contacts",
    title: "external_api_group_contacts",
    subtitle: "academy_page_subtitle_002",
    description:
      "academy_page_description_002",
    icon: "◎",
    estimatedMinutes: 5,
    help: [
      {
        id: "overview",
        title: "academy_page_title_008",
        body:
          "academy_page_body_011",
      },
      {
        id: "first-contact",
        title: "academy_page_title_009",
        body:
          "academy_page_body_012",
      },
      {
        id: "create",
        title: "academy_page_title_010",
        body:
          "academy_page_body_013",
      },
      {
        id: "csv",
        title: "academy_page_title_011",
        body:
          "academy_page_body_014",
      },
      {
        id: "search",
        title: "academy_page_title_012",
        body:
          "academy_page_body_015",
      },
      {
        id: "open",
        title: "academy_page_title_013",
        body:
          "academy_page_body_016",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="contacts-header"]',
        title: "academy_page_title_014",
        body:
          "academy_page_body_017",
        placement: "bottom",
      },
      {
        id: "empty-state",
        target: '[data-academy="contacts-empty-state"]',
        title: "academy_page_title_015",
        body:
          "academy_page_body_018",
        placement: "bottom",
        skipIfMissing: true,
      },
      {
        id: "csv",
        target: '[data-academy="contacts-import-export"]',
        title: "academy_page_title_016",
        body:
          "academy_page_body_019",
        placement: "bottom",
        skipIfMissing: true,
      },
      {
        id: "search",
        target: '[data-academy="contacts-search"]',
        title: "academy_page_title_017",
        body:
          "academy_page_body_020",
        placement: "bottom",
        skipIfMissing: true,
      },
      {
        id: "actions",
        target: '[data-academy="contacts-actions"]',
        title: "academy_page_title_018",
        body:
          "academy_page_body_021",
        placement: "bottom",
        skipIfMissing: true,
      },
      {
        id: "table",
        target: '[data-academy="contacts-table"]',
        title: "academy_page_title_019",
        body:
          "academy_page_body_022",
        placement: "top",
        skipIfMissing: true,
      },
    ],
  },

  leads: {
    key: "leads",
    route: "/menu/sales/leads",
    title: "external_api_group_leads",
    subtitle: "academy_page_subtitle_003",
    description: "academy_page_description_003",
    icon: "L",
    estimatedMinutes: 5,
    help: [
      {
        id: "flow",
        title: "academy_page_title_020",
        body: "academy_page_body_023",
      },
      {
        id: "tabs",
        title: "academy_page_title_021",
        body: "academy_page_body_024",
      },
      {
        id: "finance",
        title: "academy_page_title_022",
        body: "academy_page_body_025",
      },
      {
        id: "convert",
        title: "academy_page_title_023",
        body: "academy_page_body_026",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="leads-header"]',
        title: "academy_page_title_024",
        body: "academy_page_body_027",
        placement: "bottom",
      },
      {
        id: "tabs",
        target: '[data-academy="leads-tabs"]',
        title: "academy_page_title_025",
        body: "academy_page_body_028",
        placement: "bottom",
      },
      {
        id: "toolbar",
        target: '[data-academy="leads-toolbar"]',
        title: "crm_activities_saved_filters",
        body: "academy_page_body_029",
        placement: "bottom",
      },
      {
        id: "table",
        target: '[data-academy="leads-table"]',
        title: "academy_page_title_026",
        body: "academy_page_body_030",
        placement: "top",
      },
    ],
  },

  tasks: {
    key: "tasks",
    route: "/menu/sales/tasks",
    title: "tasks",
    subtitle: "academy_page_subtitle_004",
    description: "academy_page_description_004",
    icon: "✓",
    estimatedMinutes: 5,
    help: [
      {
        id: "purpose",
        title: "academy_page_title_027",
        body: "academy_page_body_031",
      },
      {
        id: "groups",
        title: "academy_page_title_028",
        body: "academy_page_body_032",
      },
      {
        id: "details",
        title: "academy_page_title_029",
        body: "academy_page_body_033",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="tasks-header"]',
        title: "academy_page_title_030",
        body: "academy_page_body_034",
        placement: "bottom",
      },
      {
        id: "tabs",
        target: '[data-academy="tasks-tabs"]',
        title: "academy_page_title_031",
        body: "academy_page_body_035",
        placement: "bottom",
      },
      {
        id: "toolbar",
        target: '[data-academy="tasks-toolbar"]',
        title: "academy_page_title_032",
        body: "academy_page_body_036",
        placement: "bottom",
      },
      {
        id: "table",
        target: '[data-academy="tasks-table"]',
        title: "academy_page_title_033",
        body: "academy_page_body_037",
        placement: "top",
      },
    ],
  },

  deals: {
    key: "deals",
    route: "/menu/sales/deals",
    title: "deals",
    subtitle: "academy_page_subtitle_005",
    description:
      "academy_page_description_005",
    icon: "◇",
    estimatedMinutes: 9,
    help: [
      {
        id: "purpose",
        title: "academy_page_title_034",
        body:
          "academy_page_body_038",
      },
      {
        id: "pipeline",
        title: "academy_page_title_035",
        body:
          "academy_page_body_039",
      },
      {
        id: "finance",
        title: "academy_page_title_036",
        body:
          "academy_page_body_040",
      },
      {
        id: "task",
        title: "academy_page_title_037",
        body:
          "academy_page_body_041",
      },
      {
        id: "activity",
        title: "academy_page_title_038",
        body:
          "academy_page_body_042",
      },
      {
        id: "timeline",
        title: "academy_page_title_039",
        body:
          "academy_page_body_043",
      },
      {
        id: "finish",
        title: "academy_page_title_040",
        body:
          "academy_page_body_044",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="deals-header"]',
        title: "academy_page_title_041",
        body:
          "academy_page_body_045",
        placement: "bottom",
      },
      {
        id: "toolbar",
        target: '[data-academy="deals-toolbar"]',
        title: "academy_page_title_042",
        body:
          "academy_page_body_046",
        placement: "bottom",
      },
      {
        id: "table",
        target: '[data-academy="deals-table"]',
        title: "academy_page_title_043",
        body:
          "academy_page_body_047",
        placement: "top",
      },
      {
        id: "pipeline-link",
        target: '[data-academy="deals-pipeline-link"]',
        title: "academy_page_title_044",
        body:
          "academy_page_body_048",
        placement: "top",
      },
    ],
  },

  personal_details: {
    key: "personal_details",
    route: "/menu/sales/contacts",
    contextual: true,
    title: "academy_page_title_045",
    subtitle: "academy_page_subtitle_006",
    description:
      "academy_page_description_006",
    icon: "◉",
    estimatedMinutes: 11,
    help: [
      {
        id: "header",
        title: "academy_page_title_046",
        body:
          "academy_page_body_049",
      },
      {
        id: "kpi",
        title: "academy_page_title_047",
        body:
          "academy_page_body_050",
      },
      {
        id: "works",
        title: "all_contact_work",
        body:
          "academy_page_body_051",
      },
      {
        id: "activities",
        title: "academy_page_title_048",
        body:
          "academy_page_body_052",
      },
      {
        id: "timeline",
        title: "academy_page_title_049",
        body:
          "academy_page_body_053",
      },
      {
        id: "timeline-filters",
        title: "academy_page_title_050",
        body:
          "academy_page_body_054",
      },
      {
        id: "files",
        title: "documents",
        body:
          "academy_page_body_055",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="personal-header"]',
        title: "academy_page_title_051",
        body:
          "academy_page_body_056",
        placement: "bottom",
      },
      {
        id: "kpi",
        target: '[data-academy="personal-kpi"]',
        title: "academy_page_title_003",
        body:
          "academy_page_body_057",
        placement: "bottom",
      },
      {
        id: "tabs",
        target: '[data-academy="personal-tabs"]',
        title: "academy_page_title_052",
        body:
          "academy_page_body_058",
        placement: "bottom",
      },
      {
        id: "works-tab",
        prepare: {
          click: '[data-academy-tab="works"]',
        },
        target: '[data-academy="personal-content"]',
        title: "academy_page_title_053",
        body:
          "academy_page_body_059",
        placement: "top",
      },
      {
        id: "history-tab",
        prepare: {
          click: '[data-academy-tab="activities"]',
        },
        target: '[data-academy="personal-timeline"]',
        title: "academy_page_title_049",
        body:
          "academy_page_body_060",
        placement: "top",
      },
      {
        id: "history-actions",
        target: '[data-academy="personal-timeline-actions"]',
        title: "academy_page_title_054",
        body:
          "academy_page_body_061",
        placement: "bottom",
      },
      {
        id: "history-filters",
        target: '[data-academy="personal-timeline-filters"]',
        title: "academy_page_title_050",
        body:
          "academy_page_body_062",
        placement: "bottom",
      },
      {
        id: "history-events",
        target: '[data-academy="personal-timeline-events"]',
        title: "academy_page_title_055",
        body:
          "academy_page_body_063",
        placement: "top",
      },
    ],
  },

  activities: {
    key: "activities",
    route: "/menu/sales/activities",
    title: "academy_page_title_038",
    subtitle: "academy_page_subtitle_007",
    description:
      "academy_page_description_007",
    icon: "☎",
    estimatedMinutes: 9,
    help: [
      {
        id: "purpose",
        title: "academy_page_title_056",
        body:
          "academy_page_body_064",
      },
      {
        id: "relation",
        title: "academy_page_title_057",
        body:
          "academy_page_body_065",
      },
      {
        id: "types",
        title: "academy_page_title_058",
        body:
          "academy_page_body_066",
      },
      {
        id: "status",
        title: "academy_page_title_059",
        body:
          "academy_page_body_067",
      },
      {
        id: "views",
        title: "academy_page_title_060",
        body:
          "academy_page_body_068",
      },
      {
        id: "timeline",
        title: "academy_page_title_061",
        body:
          "academy_page_body_069",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="activities-header"]',
        title: "academy_page_title_062",
        body:
          "academy_page_body_070",
        placement: "bottom",
      },
      {
        id: "summary",
        target: '[data-academy="activities-summary"]',
        title: "academy_page_title_063",
        body:
          "academy_page_body_071",
        placement: "bottom",
      },
      {
        id: "filters",
        target: '[data-academy="activities-filters"]',
        title: "academy_page_title_064",
        body:
          "academy_page_body_072",
        placement: "bottom",
      },
      {
        id: "views",
        target: '[data-academy="activities-view-switch"]',
        title: "academy_page_title_065",
        body:
          "academy_page_body_073",
        placement: "bottom",
      },
      {
        id: "workspace",
        target: '[data-academy="activities-workspace"]',
        title: "academy_page_title_066",
        body:
          "academy_page_body_074",
        placement: "top",
      },
      {
        id: "create",
        target: '[data-academy="activities-create"]',
        title: "academy_page_title_067",
        body:
          "academy_page_body_075",
        placement: "bottom",
      },
    ],
  },

  pipeline: {
    key: "pipeline",
    route: "/menu/sales/pipeline",
    title: "pipeline",
    subtitle: "academy_page_subtitle_008",
    description:
      "academy_page_description_008",
    icon: "⇢",
    estimatedMinutes: 6,
    help: [
      {
        id: "meaning",
        title: "academy_page_title_035",
        body:
          "academy_page_body_076",
      },
      {
        id: "stage",
        title: "academy_page_title_068",
        body:
          "academy_page_body_077",
      },
      {
        id: "order",
        title: "academy_page_title_069",
        body:
          "academy_page_body_078",
      },
      {
        id: "system",
        title: "academy_page_title_070",
        body:
          "academy_page_body_079",
      },
      {
        id: "delete",
        title: "academy_page_title_071",
        body:
          "academy_page_body_080",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="pipeline-header"]',
        title: "academy_page_title_072",
        body:
          "academy_page_body_081",
        placement: "bottom",
      },
      {
        id: "toolbar",
        target: '[data-academy="pipeline-toolbar"]',
        title: "academy_page_title_073",
        body:
          "academy_page_body_082",
        placement: "bottom",
      },
      {
        id: "table",
        target: '[data-academy="pipeline-table"]',
        title: "academy_page_title_074",
        body:
          "academy_page_body_083",
        placement: "top",
      },
      {
        id: "create",
        target: '[data-academy="pipeline-create"]',
        title: "academy_page_title_075",
        body:
          "academy_page_body_084",
        placement: "bottom",
      },
    ],
  },

  marketing: {
    key: "marketing",
    route: "/menu/marketing",
    title: "marketing",
    subtitle: "academy_marketing_subtitle",
    description: "academy_marketing_description",
    icon: "✦",
    estimatedMinutes: 10,
    help: [
      {
        id: "overview",
        title: "academy_marketing_help_overview_title",
        body: "academy_marketing_help_overview_body",
      },
      {
        id: "wizard",
        title: "academy_marketing_help_wizard_title",
        body: "academy_marketing_help_wizard_body",
      },
      {
        id: "draft",
        title: "academy_marketing_help_draft_title",
        body: "academy_marketing_help_draft_body",
      },
      {
        id: "email-editor",
        title: "academy_marketing_help_editor_title",
        body: "academy_marketing_help_editor_body",
      },
      {
        id: "preview",
        title: "academy_marketing_help_preview_title",
        body: "academy_marketing_help_preview_body",
      },
      {
        id: "readiness",
        title: "academy_marketing_help_readiness_title",
        body: "academy_marketing_help_readiness_body",
      },
      {
        id: "telegram",
        title: "academy_marketing_help_telegram_title",
        body: "academy_marketing_help_telegram_body",
      },
      {
        id: "birthday",
        title: "academy_marketing_help_birthday_title",
        body: "academy_marketing_help_birthday_body",
      },
      {
        id: "test",
        title: "academy_marketing_help_test_title",
        body: "academy_marketing_help_test_body",
      },
      {
        id: "result",
        title: "academy_marketing_help_result_title",
        body: "academy_marketing_help_result_body",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="marketing-header"]',
        title: "academy_marketing_step_header_title",
        body: "academy_marketing_step_header_body",
        placement: "bottom",
      },
      {
        id: "create",
        target: '[data-academy="marketing-create"]',
        title: "academy_marketing_step_create_title",
        body: "academy_marketing_step_create_body",
        placement: "bottom",
      },
      {
        id: "wizard",
        prepare: {
          click:
            '[data-academy="marketing-create"] .vcrm-btn.primary',
        },
        target: '[data-academy="marketing-wizard-navigation"]',
        title: "academy_marketing_step_wizard_title",
        body: "academy_marketing_step_wizard_body",
        placement: "bottom",
      },
      {
        id: "basics",
        prepare: {
          dispatch: "vcrm:academy-marketing-step",
          detail: { step: 0 },
        },
        target: '[data-academy="marketing-wizard-basics"]',
        title: "academy_marketing_step_basics_title",
        body: "academy_marketing_step_basics_body",
        placement: "right",
      },
      {
        id: "preview",
        target: '[data-academy="marketing-fixed-preview"]',
        title: "academy_marketing_step_preview_title",
        body: "academy_marketing_step_preview_body",
        placement: "left",
      },
      {
        id: "fullscreen-preview",
        prepare: {
          click: '[data-academy="marketing-preview-fullscreen"]',
        },
        target: '[data-academy="marketing-fullscreen-preview"]',
        title: "academy_marketing_step_fullscreen_title",
        body: "academy_marketing_step_fullscreen_body",
        placement: "bottom",
      },
      {
        id: "message",
        prepare: {
          click:
            '[data-academy="marketing-fullscreen-preview-close"]',
          dispatch: "vcrm:academy-marketing-step",
          detail: { step: 1 },
        },
        target: '[data-academy="marketing-email-editor"]',
        title: "academy_marketing_step_message_title",
        body: "academy_marketing_step_message_body",
        placement: "right",
      },
      {
        id: "recipients",
        prepare: {
          dispatch: "vcrm:academy-marketing-step",
          detail: { step: 2 },
        },
        target: '[data-academy="marketing-audience-readiness"]',
        title: "academy_marketing_step_recipients_title",
        body: "academy_marketing_step_recipients_body",
        placement: "right",
      },
      {
        id: "conditions",
        prepare: {
          dispatch: "vcrm:academy-marketing-step",
          detail: { step: 3 },
        },
        target: '[data-academy="marketing-wizard-conditions"]',
        title: "academy_marketing_step_conditions_title",
        body: "academy_marketing_step_conditions_body",
        placement: "right",
      },
      {
        id: "test",
        target: '[data-academy="marketing-test-delivery"]',
        title: "academy_marketing_step_test_title",
        body: "academy_marketing_step_test_body",
        placement: "left",
      },
      {
        id: "review",
        prepare: {
          dispatch: "vcrm:academy-marketing-step",
          detail: { step: 4 },
        },
        target: '[data-academy="marketing-wizard-review"]',
        title: "academy_marketing_step_review_title",
        body: "academy_marketing_step_review_body",
        placement: "right",
      },
      {
        id: "tabs",
        prepare: {
          click:
            '[data-academy="marketing-campaign-drawer-close"]',
        },
        target: '[data-academy="marketing-tabs"]',
        title: "academy_marketing_step_tabs_title",
        body: "academy_marketing_step_tabs_body",
        placement: "bottom",
      },
      {
        id: "overview",
        prepare: {
          click: '[data-academy-tab="marketing-overview"]',
        },
        target: '[data-academy="marketing-overview"]',
        title: "academy_marketing_step_overview_title",
        body: "academy_marketing_step_overview_body",
        placement: "top",
      },
      {
        id: "campaigns",
        prepare: {
          click: '[data-academy-tab="marketing-campaigns"]',
        },
        target: '[data-academy="marketing-campaigns"]',
        title: "academy_marketing_step_campaigns_title",
        body: "academy_marketing_step_campaigns_body",
        placement: "top",
      },
      {
        id: "archive",
        prepare: {
          click: '[data-academy-tab="marketing-archive"]',
        },
        target: '[data-academy="marketing-archive"]',
        title: "academy_marketing_step_archive_title",
        body: "academy_marketing_step_archive_body",
        placement: "top",
      },
      {
        id: "coupons",
        prepare: {
          click: '[data-academy-tab="marketing-coupons"]',
        },
        target: '[data-academy="marketing-coupons"]',
        title: "academy_marketing_step_coupons_title",
        body: "academy_marketing_step_coupons_body",
        placement: "top",
      },
      {
        id: "jobs",
        prepare: {
          click: '[data-academy-tab="marketing-jobs"]',
        },
        target: '[data-academy="marketing-jobs"]',
        title: "academy_marketing_step_jobs_title",
        body: "academy_marketing_step_jobs_body",
        placement: "top",
      },
      {
        id: "stats",
        prepare: {
          click: '[data-academy-tab="marketing-stats"]',
        },
        target: '[data-academy="marketing-stats"]',
        title: "academy_marketing_step_stats_title",
        body: "academy_marketing_step_stats_body",
        placement: "top",
      },
    ],
  },

  settings: {
    key: "settings",
    route: "/menu/settings/crm",
    title: "crm_settings",
    subtitle: "academy_page_subtitle_010",
    description:
      "academy_page_description_010",
    icon: "⚙",
    estimatedMinutes: 15,
    help: [
      {
        id: "tenant",
        title: "academy_page_title_092",
        body:
          "academy_page_body_105",
      },
      {
        id: "branding",
        title: "crm_settings_branding_title",
        body:
          "academy_page_body_106",
      },
      {
        id: "email",
        title: "preset_source_email_description",
        body:
          "academy_page_body_107",
      },
      {
        id: "ai",
        title: "crm_settings_rate_limit_group_ai",
        body:
          "academy_page_body_108",
      },
      {
        id: "google",
        title: "academy_page_title_093",
        body:
          "academy_page_body_109",
      },
      {
        id: "schedule",
        title: "academy_page_title_094",
        body:
          "academy_page_body_110",
      },
      {
        id: "files",
        title: "academy_page_title_095",
        body:
          "academy_page_body_111",
      },
      {
        id: "limits",
        title: "crm_settings_rate_limit_title",
        body:
          "academy_page_body_112",
      },
      {
        id: "sources",
        title: "crm_settings_tab_sources",
        body:
          "academy_page_body_113",
      },
      {
        id: "pipeline",
        title: "pipeline",
        body:
          "academy_page_body_114",
      },
      {
        id: "custom-fields",
        title: "academy_page_title_096",
        body:
          "academy_page_body_115",
      },
      {
        id: "api",
        title: "academy_page_title_097",
        body:
          "academy_page_body_116",
      },
      {
        id: "save",
        title: "academy_page_title_098",
        body:
          "academy_page_body_117",
      },
    ],
    steps: [
      {
        id: "header",
        target: '[data-academy="crm-settings-header"]',
        title: "crm_settings",
        body:
          "academy_page_body_118",
        placement: "bottom",
      },
      {
        id: "tabs",
        target: '[data-academy="crm-settings-tabs"]',
        title: "academy_page_title_099",
        body:
          "academy_page_body_119",
        placement: "bottom",
      },
      {
        id: "branding",
        prepare: {
          click: '[data-academy-tab="crm-settings-branding"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "crm_settings_branding_title",
        body:
          "academy_page_body_120",
        placement: "top",
      },
      {
        id: "email",
        prepare: {
          click: '[data-academy-tab="crm-settings-email"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "preset_source_email_description",
        body:
          "academy_page_body_121",
        placement: "top",
      },
      {
        id: "ai",
        prepare: {
          click: '[data-academy-tab="crm-settings-ai"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "crm_settings_rate_limit_group_ai",
        body:
          "academy_page_body_122",
        placement: "top",
      },
      {
        id: "google",
        prepare: {
          click: '[data-academy-tab="crm-settings-google"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "academy_page_title_100",
        body:
          "academy_page_body_123",
        placement: "top",
      },
      {
        id: "schedule",
        prepare: {
          click: '[data-academy-tab="crm-settings-workSchedule"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "academy_page_title_101",
        body:
          "academy_page_body_124",
        placement: "top",
      },
      {
        id: "files",
        prepare: {
          click: '[data-academy-tab="crm-settings-files"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "crm_files_settings_eyebrow",
        body:
          "academy_page_body_125",
        placement: "top",
      },
      {
        id: "rate-limit",
        prepare: {
          click: '[data-academy-tab="crm-settings-rateLimit"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "crm_settings_rate_limit_title",
        body:
          "academy_page_body_126",
        placement: "top",
      },
      {
        id: "sources",
        prepare: {
          click: '[data-academy-tab="crm-settings-sources"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "academy_page_title_102",
        body:
          "academy_page_body_127",
        placement: "top",
      },
      {
        id: "pipeline",
        prepare: {
          click: '[data-academy-tab="crm-settings-pipeline"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "pipeline",
        body:
          "academy_page_body_128",
        placement: "top",
      },
      {
        id: "external-api",
        prepare: {
          click: '[data-academy-tab="crm-settings-externalApi"]',
        },
        target: '[data-academy="crm-settings-panel"]',
        title: "academy_page_title_097",
        body:
          "academy_page_body_129",
        placement: "top",
      },
      {
        id: "save",
        target: '[data-academy="crm-settings-actions"]',
        title: "academy_page_title_103",
        body:
          "academy_page_body_130",
        placement: "bottom",
      },
    ],
  },
};

export const ACADEMY_PAGE_ORDER = [
  "dashboard",
  "contacts",
  "personal_details",
  "leads",
  "tasks",
  "activities",
  "pipeline",
  "deals",
  "marketing",
  "settings",
];

export function resolveAcademyPage(pathname = "") {
  if (/\/menu\/sales\/contacts\/\d+\/personal-details/.test(pathname)) {
    return "personal_details";
  }
  if (pathname.startsWith("/menu/dashboard")) return "dashboard";
  if (pathname.startsWith("/menu/sales/contacts")) return "contacts";
  if (pathname.startsWith("/menu/sales/leads")) return "leads";
  if (pathname.startsWith("/menu/sales/tasks")) return "tasks";
  if (pathname.startsWith("/menu/sales/activities")) return "activities";
  if (pathname.startsWith("/menu/sales/pipeline")) return "pipeline";
  if (pathname.startsWith("/menu/sales/deals")) return "deals";
  if (pathname.startsWith("/menu/marketing")) return "marketing";
  if (pathname.startsWith("/menu/settings")) return "settings";
  return null;
}
